import { useRef, useState } from 'react'

export const initialPaymentState = {
  isLoadingCheckIfCustomerHasSavedCards: true,
  isLoadingCardsData: true,
  hasSavedCards: null, // null if is has not been checked, true if has saved cards, false if has not saved cards
  cardsData: [],
  selectedPaymentCard: {},
  selectedCardToDelete: {},
  selectedPaymentOption: '',
  gateway: '',
  isSavingCard: false,
  hasConfirmedPaymentMethod: false,
  isPaying: false,
  canUserPay: false,
  paymentSuccess: false,
  paymentOrderResult: {},
  isUsingSavedCards: false,
  paymentError: '',
  installments: 1,
  showSavedCardModal: false,
  isPayingWithPinflagMethods: false,
  useOneClick: false,
  purchaseOrderResult: {},
  showGatewayForm: false,
  isLoadingGatewayForm: true,
  isConfirmingPaymentMethod: false,
  forceNewPayment: false,
  cardNumber: '',
  cardExpiryDate: '',
  cardCvv: '',
  paymentSuccessfulInformation: {},
  selectedNativePaymentMethod: '',
  nativePaymentEnabled: true
}

export const usePaymentState = (
  userInfo,
  addressInfo,
  cartData,
  ecommerceInfo,
  clientMetaData
) => {
  const [paymentState, setPaymentState] = useState(initialPaymentState)
  const userToken = useRef(null)

  const paymentOrderData = {
    customer: userInfo,
    address: addressInfo,
    cart: cartData,
    ecommerce: ecommerceInfo,
    clientMeta: clientMetaData
  }
  const purchaseOrderData = {
    ...paymentOrderData,
    paymentMethod: paymentState.selectedPaymentOption,
    gateway: paymentState.gateway
  }

  const setGateway = (value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      gateway: value
    }))
  }

  const setIsPaying = (value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      isPaying: value
    }))
  }

  const setPaymentError = (message) => {
    setPaymentState((prevState) => ({
      ...prevState,
      paymentError: message
    }))
  }

  const setIsUsingSavedCards = (value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      isUsingSavedCards: value
    }))
  }

  const setIsSavingCard = (value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      isSavingCard: value
    }))
  }

  const setInstallments = (value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      installments: value
    }))
  }

  const setShowSavedCardModal = (value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      showSavedCardModal: value
    }))
  }

  const setPurchaseOrderResult = (value) => {
    setPaymentState((prevState) => ({
      ...prevState,
      purchaseOrderResult: value
    }))
  }

  const setIsPayingWithPinflagMethods = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      isPayingWithPinflagMethods: value
    }))
  }

  const setPaymentOrderResult = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      paymentOrderResult: value
    }))
  }

  const setIsLoadingGatewayForm = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      isLoadingGatewayForm: value
    }))
  }

  const setIsConfirmingPaymentMethod = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      isConfirmingPaymentMethod: value
    }))
  }

  const setForceNewPayment = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      forceNewPayment: value
    }))
  }

  const setPaymentMethod = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      selectedPaymentOption: value
    }))
  }

  const setUseOneClick = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      useOneClick: value
    }))
  }

  const setSelectedNativePaymentMethod = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      selectedNativePaymentMethod: value
    }))
  }

  const setSelectedCardToDelete = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      selectedCardToDelete: value
    }))
  }

  const setShowGatewayForm = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      showGatewayForm: value
    }))
  }

  const setHasConfirmedPaymentMethod = (value) => {
    setPaymentState((paymentState) => ({
      ...paymentState,
      hasConfirmedPaymentMethod: value
    }))
  }

  const resetCardData = () => {
    setPaymentState((prevState) => ({
      ...prevState,
      cardNumber: '',
      cardExpiryDate: '',
      cardCvv: '',
      installments: 1
    }))
  }

  return {
    paymentState,
    userToken,
    setPaymentState,
    paymentOrderData,
    purchaseOrderData,
    paymentSetters: {
      setGateway,
      setIsPaying,
      setPaymentError,
      setIsUsingSavedCards,
      setIsSavingCard,
      setInstallments,
      setShowSavedCardModal,
      setPurchaseOrderResult,
      setIsPayingWithPinflagMethods,
      setPaymentOrderResult,
      setIsLoadingGatewayForm,
      setIsConfirmingPaymentMethod,
      setForceNewPayment,
      setPaymentMethod,
      setUseOneClick,
      setSelectedNativePaymentMethod,
      setSelectedCardToDelete,
      setShowGatewayForm,
      setHasConfirmedPaymentMethod,
      resetCardData
    }
  }
}
